module.exports = __webpack_public_path__ + "static/media/close.440804e6.svg";